export function giftDescriptor(message) {
  if (message?.recalled || message?.type === 'system') return null;
  try {
    const raw = message?.raw?.ex;
    const ex = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (ex?.source !== 'jc-wallet-gift' || !/^[A-Za-z0-9_-]{16,128}$/.test(ex.gift_id || '')) return null;
    return { id: ex.gift_id, note: String(message.text || '').replace(/^🎁\s?/, '') };
  } catch { return null; }
}
